import { render, staticRenderFns } from "./GuestInfoFrame.vue?vue&type=template&id=aab2e92c&scoped=true"
import script from "./GuestInfoFrame.vue?vue&type=script&lang=js"
export * from "./GuestInfoFrame.vue?vue&type=script&lang=js"
import style0 from "./GuestInfoFrame.vue?vue&type=style&index=0&id=aab2e92c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab2e92c",
  null
  
)

export default component.exports